import keyMirror from 'keymirror';

export const offlineRetryModalActionTypes = keyMirror({
	OPEN_OFFLINE_RETRY_MODAL: null,
	CLOSE_OFFLINE_RETRY_MODAL: null,
});

export const DEFAULT_AUTO_RETRY_INTERVAL_SEC = [3, 5, 10, 30, 60];

export const getIntervalForIndex = (i: number) => {
	const arr = DEFAULT_AUTO_RETRY_INTERVAL_SEC;
	const idx = Math.min(i, arr.length - 1);
	return arr[idx];
};
